import { AnyObject } from '@apeiron/temp'
import { useMutation } from '@apollo/client'
import useMakeBuyDailyCheckInShopItem from '@src/deserialize/hook/useMakeBuyDailyCheckInShopItem'
import useMakeResult from '@src/deserialize/hook/useMakeResult'
import graphql from '@src/graphql/mutation/buyDailyCheckInShopItem'
import { useCallback } from 'react'

const useBuyDailyCheckInShopItem = (): Hook => {
  const [buy, { loading }] = useMutation(graphql)

  const { makeResult } = useMakeResult()

  const { makeBuyResult } = useMakeBuyDailyCheckInShopItem()

  const mutate = useCallback(
    async (itemId: string): Promise<boolean> => {
      const response = await buy({
        variables: {
          input: { shopItemID: itemId }
        }
      })

      const result = makeResult<AnyObject>(response) ?? {}

      const success = makeBuyResult(result)

      return success
    },
    [buy, makeBuyResult, makeResult]
  )

  return {
    mutate,
    loading
  }
}

type Hook = {
  mutate: (itemId: string) => Promise<boolean>
  loading: boolean
}

export default useBuyDailyCheckInShopItem
